<template>
  <modal
    ref="addContract"
    :ok-disabled="loading"
    :ok-title="!$parent.edit ? 'Pridať' : 'Upraviť'"
    :title="
      !$parent.edit ? 'Pridať zmluvné hodnoty' : 'Upraviť zmluvné hodnoty'
    "
    cancel-title="Zrušiť"
    full-height
    name="add-contract"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveContract"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-form-group
              label-cols-sm="5"
              label="Súčasný dodávateľ"
              label-for="providerID"
            >
              <b-form-select
                v-model="form.providerID"
                :select-size="1"
                name="providerID"
              >
                <option :value="null">--Nedefinované--</option>
                <option
                  v-for="item in attributes.provider"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Cena VT (€ bez dph/MWh)"
              label-for="price2VT"
            >
              <vue-autonumeric
                v-model="form.price2VT"
                class="form-control"
                name="price2VT"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Cena NT (€ bez dph/MWh)"
              label-for="price2NT"
            >
              <vue-autonumeric
                v-model="form.price2NT"
                class="form-control"
                name="price2NT"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Mesačná platba (€ bez dph)"
              label-for="monthlyPayment"
            >
              <vue-autonumeric
                v-model="form.monthlyPayment"
                class="form-control"
                name="monthlyPayment"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Predpokl. ročná spotreba VT (MWh)"
              label-for="yearlyConsumptionVT"
            >
              <vue-autonumeric
                v-model="form.yearlyConsumptionVT"
                class="form-control"
                name="yearlyConsumptionVT"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Predpokl. ročná spotreba NT (MWh)"
              label-for="yearlyConsumptionNT"
            >
              <vue-autonumeric
                v-model="form.yearlyConsumptionNT"
                class="form-control"
                name="yearlyConsumptionNT"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Tolerancia odberu - spodná (%)"
              label-for="tolLower"
            >
              <vue-autonumeric
                v-model="form.tolLower"
                class="form-control"
                name="tolLower"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Tolerancia odberu - horná (%)"
              label-for="tolUpper"
            >
              <vue-autonumeric
                v-model="form.tolUpper"
                class="form-control"
                name="tolUpper"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Dátum zmeny"
              label-for="changeDate"
            >
              <single-date
                v-model="form.changeDate"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('changeDate') }"
                class="form-control"
                data-vv-as="Dátum zmeny"
                name="changeDate"
              />
              <b-form-invalid-feedback>
                {{ errors.first('changeDate') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate'
import { mapState } from 'vuex'

export default {
  components: {
    Modal,
    SingleDate,
  },
  data() {
    return {
      loading: false,
      attributes: [],
      form: {},
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
  },
  methods: {
    fetchData() {
      this.form = {
        energetics_id: parseInt(this.$route.params.energetics_id),
      }
      if (this.$parent.edit) {
        this.loading = true
      }
      this.axios
        .all([
          this.$api.get('attributes/get', {
            params: {
              select: 'energetic_contracts',
              filter: { typeID: 1 },
            },
          }),
          this.$parent.edit
            ? this.$api.get(`energetics/${this.$parent.id}/contract/get_form`)
            : '',
        ])
        .then(
          this.axios.spread((attr, formdata) => {
            this.attributes = attr.data
            if (this.$parent.edit) {
              this.form = formdata.data.data
            }
            this.loading = false
          }),
        )
    },
  },
}
</script>
